// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import AppMain from './App-main.vue';

import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import VueProgressBar from 'vue-progressbar';
import locale from 'element-ui/lib/locale/lang/vi';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import 'element-ui/lib/theme-chalk/display.css';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/css/common.css';
import '@/assets/css/new-style.css';
import '@/assets/css/custom-element.css';

// import "@/configProgressbar.js";
import '@/utils/axios.js';
import * as mixins from '@/mixins/mixins';
import * as httpService from '@/utils/httpService';

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(ElementUI, {
  locale
});
Vue.component(CollapseTransition.name, CollapseTransition);

// config api
Vue.config.productionTip = false;
Vue.config.performance = true;
process.NODE_ENV === 'development' &&
  (Vue.config.errorHandler = function (err, vm, info) {
    console.log('error: ', err);
    console.log('information: ', info);
  });

Vue.use(VueGoogleMaps, {
  load: {
    region: 'VI',
    language: 'vi',
    key: 'AIzaSyCcd_SqIX103j_EF2gMQ0x77rdUHoo-u38',
    libraries: 'places,drawing,visualization',
    autobindAllEvents: false,
    installComponents: true
  }
});

Vue.use(VueProgressBar, {
  color: 'red',
  failedColor: 'red',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
});

// global mixins
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key]);
});

Object.keys(httpService).forEach(key => {
  Vue.mixin(httpService[key]);
});

// custom directive autofocus
Vue.directive('focus', {
  bind: function (el, binding, vnode) {
    el.children[0].focus();
  },
  inserted: function (el, binding, vnode) {
    el.children[0].focus();
  }
});

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  components: { AppMain },
  template: '<AppMain/>'
});



// WEBPACK FOOTER //
// ./src/main.js